import type { ComponentPublicInstance, ComponentOptionsMixin } from 'vue';
import { difference, isString, pick } from 'lodash'

import { getComponentProps } from '../util';

declare module '@vue/runtime-core' {
    interface ComponentCustomProperties {
        $componentProps: typeof $componentProps
    }
}

export function $componentProps(componentOrComponentName, excludes?: string[]) {

    const thisComp = this as ComponentPublicInstance;
    let component = componentOrComponentName;

    if(isString(componentOrComponentName)){
        component = thisComp.$options.components[componentOrComponentName];
    }

    let keys = Object.keys(getComponentProps(component));

    if(excludes){
        keys = difference(keys, excludes);
    }

    return pick(thisComp.$props, keys);
}

export const componentPropsMixin: ComponentOptionsMixin = {

    methods: {
        $componentProps
    }
}